export default "__VITE_ASSET__BEx5mGcB__"